<template>
  <div>
    <div class="settings-top-bar sticky-header" ref="optionsTopBar">
      <div class="text-right">
        <p class="">
          <a class="btn btn-success btn-icon mar-rt-10"  @click.prevent="validate" :title="$t('general.saveChanges')">
            <i class="ti-save"></i>
          </a>
        </p>
      </div>
    </div>
    <form>
      <div class="card mar-to-15">
        <div class="card-content">
          <div class="row">
            <div class="col-sm-12 ">
              <div class="form-group">
                <label>{{$t('settingsTips.state')}}</label>
                <br/>
                <p-switch v-model="model.tips_in_use" type="success" @input="handleActive($event)"></p-switch>
              </div>
              <div v-if="model.tips_in_use">
                <div class="form-group">
                  <label>{{$t('settingsTips.tipsTaxes')}}</label>
                  <v-select v-model="model.tips_taxes"
                            multiple
                            :options="taxes"
                            value="id"
                            label="name">
                  </v-select>
                  <small class="text-danger" v-if="errors.has(model.tips_taxes)">
                    {{ getError(model.tips_taxes) }}
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Input, Button, Select} from 'element-ui'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import {mapFields} from 'vee-validate'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  import vSelect from 'vue-select'
  Vue.component('v-select', vSelect)
  Vue.use(Button)
  Vue.use(Input)
  Vue.use(Select)

  export default {
    components: {
      [Button.name]: Button,
      [Input.name]: Input,
      [Select.name]: Select,
      PSwitch
    },
    props: {
      defaultData: {},
      modeldata: {},
      taxesData: {}
    },
    watch: {
      defaultData (value) {
        this.defaults = value
      },
      modeldata (value) {
        this.model = value
      },
      taxesData (value) {
        this.taxes = value
      }
    },
    data () {
      return {
        model: this.value || this.modeldata,
        defaults: this.value || this.defaultData,
        taxes: this.value || this.taxesData
      }
    },
    computed: {
      ...mapFields(['title', 'description'])
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.saveDetails()
          }
        })
      },
      handleErrors (errors) {
        for (var prop in errors) {
          if (errors.hasOwnProperty(prop)) {
            this.errors.add(prop, errors[prop][0])
          }
        }
      },
      saveDetails () {
        var companyID = this.$session.get('selectedCompany')
        var data = {
          'token': this.$session.get('token'),
          'tips_taxes': JSON.stringify(this.model.tips_taxes)
        }

        var self = this
        this.apiRequest('/settings/general/' + companyID, 'PUT', data, function (response) {
          if (response.status === true) {
            swal({'text': self.$t('settingsTips.tipsSuccess'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
            self.$session.set('selectedCompanyData', self.buildCompanySessionData(response.data[0]))
          } else {
            self.handleErrors(response.errors)
            // swal({'text': 'Something went wrong, please try again later...', 'type': 'error', 'showConfirmButton': false, 'timer': 2000})
          }
        })
      },
      handleActive (e) {
        var companyID = this.$session.get('selectedCompany')
        var data = {
          'token': this.$session.get('token'),
          'tips_in_use': this.model.tips_in_use ? 1 : 0
        }
        if (data['tips_in_use'] === 1) {
          this.$session.set('tips_use', true)
        } else {
          this.$session.set('tips_use', false)
        }
        // let actionText = this.model.tips_in_use ? 'enabled' : 'disabled'
        var self = this
        this.apiRequest('/settings/general/' + companyID, 'PUT', data, function (response) {
          if (response.status === true) {
            swal({'text': self.$t('settingsTips.tipsSuccess'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
          } else {
            self.handleErrors(response.errors)
            self.model.tips_in_use = !self.model.tips_in_use
            swal(
              '',
              response.errors['id'] ? response.errors['id'] : self.$t('validationa.wentWrong'),
              'error'
            )
          }
        })
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/Tabs/Tips.vue